module.exports = __webpack_public_path__ + "static/img/到院导航@3x.b219d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/到院导航@3x.png
// module id = 306
// module chunks = 363 364